import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="M20 0C21.1046 0 22 0.89543 22 2V22C22 23.1046 21.1046 24 20 24H4C2.89543 24 2 23.1046 2 22V2C2 0.89543 2.89543 0 4 0H20ZM12 21C11.4477 21 11 21.4477 11 22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22C13 21.4477 12.5523 21 12 21Z" />
    </svg>
  );
}

export default Icon;
